"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStoredState = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../constants");
const logger = (0, _checkoutUtils.getLogger)(_constants.APP_NAME, _checkoutUtils.LogLevel.Error);
const getStoredValue = (key, initialValue) => {
  const value = localStorage.getItem(key);
  if (value === null) {
    return initialValue;
  }
  try {
    return JSON.parse(value);
  } catch (error) {
    logger(error);
    return initialValue;
  }
};
const setStoredValue = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

// eslint-disable-next-line @typescript-eslint/ban-types -- this is a helper type, and is valid
const isFunction = arg => typeof arg === 'function';
const useStoredState = (key, initialValue, suffix = '') => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const sanitized = `${getTestId(key)}${suffix ? '-' : ''}${suffix}`;
  const [state, setState] = (0, _react.useState)(getStoredValue(sanitized, initialValue));
  return [state, (0, _react.useCallback)(value => {
    setState(current => {
      const toSet = isFunction(value) ? value(current) : value;
      setStoredValue(sanitized, toSet);
      return toSet;
    });
  }, [sanitized])];
};
exports.useStoredState = useStoredState;